import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminDashboardPage } from './useAdminDashboardPage';
import { AdminDashboardDesktop } from './AdminDashboardDesktop';
import { AdminDashboardMobileView } from './AdminDashboardMobileView';

function useIsMobile(bp = 768) {
  const [m, setM] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < bp : false,
  );
  useEffect(() => {
    const fn = () => setM(window.innerWidth < bp);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, [bp]);
  return m;
}

export function Dashboard() {
  const ctx = useAdminDashboardPage();
  const isMobile = useIsMobile();

  // Se a escola ainda não concluiu as etapas de implantação e não pulou o wizard, redireciona para o Setup
  if (ctx.mostrarWizard && !ctx.setupLoading) {
    return <Navigate to="/admin/setup" replace />;
  }

  if (!isMobile) {
    return (
      <div
        className="adm-desk-host"
        data-tour="dash.diretor.hero"
        style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}
      >
        <AdminDashboardDesktop ctx={ctx} />
      </div>
    );
  }

  return <AdminDashboardMobileView ctx={ctx} />;
}
